import VillagePage from '@/components/VillagePage';

const ArsEnRe = () => {
  return (
    <VillagePage
      villageName="Ars-en-Ré"
      description="Village pittoresque avec son clocher noir et blanc emblématique, Ars-en-Ré est un joyau de l'Île de Ré entouré de marais salants."
      attractions={[
        "Clocher noir et blanc (amer)",
        "Marais salants",
        "Port ostréicole",
        "Ruelles fleuries",
        "Galeries d'art",
        "Église Saint-Étienne"
      ]}
      bikeRoutes={[
        "Circuit des marais salants (8 km)",
        "Vers Les Portes-en-Ré (7 km)",
        "Vers Saint-Clément (5 km)",
        "Tour du Fier d'Ars (10 km)"
      ]}
      practicalInfo={{
        beaches: ["Plage de la Grange", "Plage du Peu Ragot"],
        restaurants: ["Restaurants du port", "Cabanes ostréicoles", "Crêperies"],
        markets: ["Marché d'été (juillet-août)"]
      }}
    />
  );
};

export default ArsEnRe;